module.exports = __webpack_public_path__ + "static/media/diaporama-spacer-image.c7b3feeb.png";